<div class="se-tag-group__tags">
  <ng-content></ng-content>
</div>
